import { Point } from '../../../shared/types/mathTypes.ts';
import { useProtocolStore } from '../../pages/protocol-view/protocolStoreProvider.tsx';
import { ContextMenu, MenuItem } from '../contextMenu.tsx';


interface Props {
    screenCoords: Point;
    onClose: () => void;
}

export function ReorderPositionsMenu({
    screenCoords,
    onClose,
}: Props) {


    const reorderPositions = useProtocolStore(state => state.reorderPositions);

    const menuItems: MenuItem[] = [
        {
            text: 'By position number',
            callback: () => reorderPositions('posNr')
        },
        {
            text: 'By tool',
            callback: () => reorderPositions('tool')
        },
    ];


    return (
        <ContextMenu
            isOpen={true}
            position={screenCoords}
            items={menuItems}
            close={onClose}
        />
    );
}
